export default __webpack_public_path__ + "static/media/kaikan_503.a67c8805.svg";